import { Textarea } from "@chakra-ui/react";
import "react-calendar/dist/Calendar.css";

import { ErrorBoundaryWithFeedback } from "@/app/components/ErrorBoundaryWithFeedback";
import type { InputMaybe } from "@/generated/graphql";

export function ContextInput({
  value,
  onChange,
  placeholder = "Add your key points here",
}: {
  value: {
    contextFromMgo: InputMaybe<string>;
  };
  onChange: (value: { contextFromMgo: InputMaybe<string> }) => void;
  placeholder?: string;
}) {
  return (
    <ErrorBoundaryWithFeedback>
      <Textarea
        value={value.contextFromMgo ?? ""}
        resize="none"
        placeholder={placeholder}
        minHeight="160px"
        onChange={(event) =>
          onChange({
            contextFromMgo: event.target.value,
          })
        }
      />
    </ErrorBoundaryWithFeedback>
  );
}
